import React, { useState, useEffect } from 'react';
import {
    ClickAwayListener,
    Menu,
    Typography
} from '@mui/material';

export default function BaseMenu(props) {

    const {
        children,
        handleMenuClose,
        menuAnchorEl,
    } = props

    return (
        <React.Fragment>
            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
                slotProps={{
                    'paper': {
                        style: {
                            color: 'white',
                            maxHeight: '400px',
                            background: 'rgba(48, 89, 69, 0.7)',
                            backdropFilter: 'blur(20px)',
                        }
                    }
                }}
            >
                    {
                        children
                        ?
                            children
                        :
                            <Typography
                                px={2}
                                color="rgb(150,150,150)"
                            >
                                Nothing to show
                            </Typography>
                    }
            </Menu>
        </React.Fragment>
    );
}